import ProductCarousel from "@/components/sections/ProductCarousel";
import FinalCTA from "@/components/sections/FinalCTA";
import { motion } from "framer-motion";
import { IMG } from "@/data/content";

export default function Croissante() {
  return (
    <div data-testid="page-croissante">
      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMG.croissantArtisan} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/85 to-black/70" />
        </div>
        <div className="relative z-10 max-w-5xl mx-auto container-px text-white">
          <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="eyebrow text-gold">Croissante</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="h-display text-4xl md:text-6xl mt-4 text-white">
            Crocante afară. <em className="text-gold not-italic">Moi înăuntru.</em>
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }} className="mt-6 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl font-display italic">
            &bdquo;Un croissant bun nu se explică mult. Se rupe, se miroase, se gustă.&rdquo;
          </motion.p>
        </div>
      </section>

      <ProductCarousel />
      <FinalCTA />
    </div>
  );
}
